import React, {useState} from "react"
import {Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink} from "reactstrap"

const homeUrl = ""
const analysis = "/personality-analysis"
const personalityList = "/personality-list"
const contactUs = "/contact-us"
const NavbarBasic = (props) => {
    const [isOpen, setIsOpen] = useState(false)
    const pathname = window.location.pathname

    console.info(pathname)
    return (<> {!pathname.match(/admin|login/g) &&
        <div style={{
            display: 'block',
            backgroundColor: "white"
        }}
             className="border-bottom border-1 navbar-with-menu"
        >
            <Navbar color="white" light expand="md" className={"navbar-with-menu"}>
                <NavbarBrand href="/"><span className="font-weight-bold dark-text">M<span
                    style={{color: "#3737EF"}}>S</span>TI</span><span
                    style={{fontSize: 16}}>ㅤ마이스터디타입 공부유형</span></NavbarBrand>
                <NavbarToggler onClick={() => {
                    setIsOpen(!isOpen)
                }}/>
                <Collapse isOpen={isOpen} navbar>
                    <Nav className="ml-auto" navbar>
                        <NavItem className="mr-3 ">
                            <NavLink href="/home" className={` ${pathname === "/home" ? 'active' : ''}`}
                                     style={{color: "#0e0e0e", marginTop: 5, marginBottom: 5}}>공부유형
                                검사</NavLink>
                        </NavItem>
                        <NavItem className="mr-3">
                            <NavLink href={personalityList}
                                     className={`${pathname === personalityList ? 'active' : ''}`}
                                     style={{color: "#0e0e0e", marginTop: 5, marginBottom: 5}}>16가지 공부유형 </NavLink>
                        </NavItem>
                        {/*<NavItem>*/}
                        {/*    <NavLink href={analysis}  className={`${pathname === analysis ? 'active' : ''}`}>유형 구성 원리</NavLink>*/}
                        {/*</NavItem>*/}
                        <NavItem>
                            <NavLink href={contactUs} className={`${pathname === contactUs ? 'active' : ''}`}
                                     style={{color: "#0e0e0e", marginTop: 5, marginBottom: 5}}>연락처</NavLink>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Navbar>
        </div>}</>
    )
}
// <Navbar
//     className="border-bottom border-1   navbar navbar-with-menu floating-nav navbar-light navbar-shadow d-flex col-12 mb-3"
//     style={{height: 60, marginTop: 5}}>
//     <div className="navbar-wrapper">
//     </div>
// </Navbar>
export default NavbarBasic
